import { createAction, props } from '@ngrx/store';
import { IOnTap } from 'app/models/on-tap';

export const loadItems = createAction('[TapTv Basic List Page] Load OnTap', props<{ barId: string; forceRefresh?: boolean }>());
export const loadItemsSuccess = createAction('[OnTap API] Load OnTap Success', props<{ items: IOnTap[] }>());
export const loadItemsFailure = createAction('[OnTap API] Load OnTap Failure', props<{ error: any }>());
